<template>
  <div class="allowance-detail">
    <nav-bar titleText="团队管理津贴明细" @goBack="goBack" :isFixed="true" rightSize="13px" ></nav-bar>
    <div class="empty"></div>
    <div class="select-month-box">

      <!-- <div class="select-month">
        <span>2020年11月</span>
        <img src="../../../assets/debtor/pullSelect.png" alt="">
        <img src="../../../assets/debtor/upSelect.png" alt="">
      </div> -->

      <van-dropdown-menu>
        <van-dropdown-item :title="`${paramTime.getFullYear()}年${paramTime.getMonth()+1}月`" ref="item">
          <van-datetime-picker
            v-model="paramTime"
            type="year-month"
            title="选择年月"
            @confirm="confirmDate"
          />
        </van-dropdown-item>
      </van-dropdown-menu>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          >
          
          <div class="list-item" v-for="(item, i) in allowanceList" :key="i">
            <p class="item-title">
              <span class="left">{{ item.created_at | formartDate }} 团队管理津贴发放</span>
              <span class="right">¥ {{ parseFloat(item.allowance_amount).toFixed(2) }}</span>
            </p>
            <p class="created-time">
              <span>结算时间</span>
              <span>{{ item.created_at }}</span>
            </p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      allowanceList : [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize: 10,
      paramTime: new Date(),

    }
  },
  components: {
    navBar,
  },
  filters: {
    formartDate(v){
      //v = '2021-01-08 16:55:52'
      const y_m = v.split('-').slice(0,2)
      const year = y_m[0]
      const month = parseInt(y_m[1])
      return `${year}.${month}`
      
      // const date = new Date(v)
      // return `${date.getFullYear()}.${date.getMonth() + 1}`
    },
    
  },
  created() {

  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },

    confirmDate(){
      this.$refs.item.toggle();
      this.reOnLoad()
    },
    reOnLoad(){
      this.allowanceList = [];
      this.finished = false;
    },
    onLoad() {
      this.getAllowanceList();
    },
    onRefresh() {
      this.page = 0;
      this.onLoad();
    },
    getAllowanceList() {
      this.page ++
      const param = {
        time: `${this.paramTime.getFullYear()}-${this.paramTime.getMonth()+1}`,
      }
      this.$api.post('/debt/member/agent/allowance', param).then(data => {
        if (this.refreshing) {
          this.allowanceList = [];
          this.finished = false;
        }

        this.allowanceList.push(...data)

        if (this.allowanceList.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }
        this.loading = false;
        if (data.current_page === data.last_page) {
          this.finished = true;
        }
        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }
        if (!this.finished && !this.loading && this.allowanceList.length <= 3) {
          this.onLoad();
        }
      })
      .catch((err) => {
        this.loading = false;
        this.finished = true;
        if(err.message) {
          this.$toast(err.message)
        }
      });
    },
  }
};
</script>

<style lang="less">
.allowance-detail {
  padding-top: 88px;
  .empty {
    width: 100%;
    height: 12px;
    background: #F5F6F7;
  }
  .select-month-box {
    padding: 16px 12px 0;

    .van-hairline--top-bottom {
      position: static;
    }
    .van-dropdown-menu {
      height: auto;
      .van-dropdown-menu__item {
        flex: 0 1 auto;
      }
      .van-dropdown-menu__title {
        height: 26px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 26px;
        margin-right: 3px;
        padding: 0;
        padding-right: 8px;
        &::after {
          top: 42%;
          right: -5px;
          // margin-top: -5px;
          border: 4px solid;
          border-color: transparent transparent currentColor currentColor;
          // -webkit-transform: rotate(-45deg);
          // transform: rotate(-45deg);
          opacity: 0.8;
          content: '';
        }
      }
      .van-picker__cancel, .van-picker__confirm {
        color: #fc740c;
      }
      .van-picker-column__item--selected {
        color: #fc740c;
      }
    }

    .list-item {
      border-bottom: 1px solid #EEEEEE;
      padding: 12px 0 13px;
      .item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          height: 26px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;

        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #F9591B;
          line-height: 23px;

        }
      }
      .created-time {
        height: 21px;
        font-size: 13px;
        color: #999999;
        line-height: 21px;
        :nth-of-type(1) {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
